import React from "react";

const SelectField = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  helperText,
  className,
  selectClassName = "big-select",
  onClick,
}) => (
  <div className={className}>
    {label ? <label className="form__label">{label}</label> : null}
    <select
      className={selectClassName}
      value={value}
      onChange={onChange}
      disabled={disabled}
      onClick={onClick}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    {helperText ? (
      <div style={{ fontSize: "0.85rem", color: "#6c757d", marginTop: "0.25rem" }}>
        {helperText}
      </div>
    ) : null}
  </div>
);

export default SelectField;
